import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DocumentsService } from 'src/app/services/documents.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { GeneralService } from 'src/app/services/general.service';
import { UsuarioService } from 'src/app/services/usuario.service';

declare var $: any;

@Component({
  selector: 'app-talonario',
  templateUrl: './talonario.component.html',
  styleUrls: ['./talonario.component.css']
})
export class TalonarioComponent implements OnInit, AfterViewInit {

  _title = 'Documentos';
  _subtitle = 'Talonario digital';

  _usuario: any = {};
  searchDocument = '';
  mostrarFiltros = false;

  loadingDocumentosGenerados = false;

 documents = [
  {
    id: 'receta',
    title: 'Receta médica',
    description: 'Genera recetas médicas digitales para tus pacientes de forma rápida y segura.',
    icon: 'fi fi-rr-prescription-bottle',
    buttonText: 'Crear receta médica',
    permission: 'doc_check_can_create_prescriptions'
  },
  {
    id: 'orden-examen',
    title: 'Orden de examen',
    description: 'Emite órdenes de exámenes y envíalas directamente a tus pacientes.',
    icon: 'fi fi-rr-add-document',
    buttonText: 'Crear orden de examen',
    permission: 'doc_check_can_create_orders'
  },
  {
    id: 'certificado',
    title: 'Certificado médico',
    description: 'Genera certificados médicos digitales para tus pacientes de forma rápida y segura.',
    icon: 'fi fi-rr-document-signed',
    buttonText: 'Crear certificado médico',
    permission: 'doc_check_can_create_certificates'
  }
];

  filtrosGenerados = {
    nombre: '',
    fechaDesde: '',
    fechaHasta: '',
    tipos: [] as string[]
  };

  tiposDocumentosGenerados = [
    'Receta',
    'Orden médica',
    'Certificado médico',
    'Licencia médica'
  ];

  documentosGenerados: any[] = [];
  documentosGeneradosFiltrados: any[] = [];

  documentosGeneradosPaginados: any[] = [];

  paginaActual = 1;
  itemsPorPagina = 10;

  opcionesItemsPorPagina = [5, 10, 20, 50, 100];

  totalPaginas = 1;

  constructor(
    private router: Router,
    public _usuarioService: UsuarioService,
    private encriptacionService: EncriptacionService,
    private documentsService: DocumentsService,
    private generalService: GeneralService
  ) { }

  ngOnInit(): void {
    this.cargarUsuario();
  }

  ngAfterViewInit(): void {
    if (typeof $ !== 'undefined') {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }

  cargarUsuario(): void {
    this._usuario = this.encriptacionService.getUserInfo();

    console.log('USUARIO SESIÓN TALONARIO:', this._usuario);

    if (this._usuario?.doc_id) {
      this.getDocumentosDoctor();
    }

    if (!this._usuario || !this._usuario.use_id) {
      return;
    }

    const service: any = this._usuarioService;

    let request: any = null;

    if (service.postBuscarUsuario) {
      request = service.postBuscarUsuario({ use_id: this._usuario.use_id });
    } else if (service.postListarusuariosSistema) {
      request = service.postListarusuariosSistema({ use_id: this._usuario.use_id });
    }

    if (!request) {
      console.warn('No se encontró método para actualizar usuario desde UsuarioService.');
      return;
    }

    if (request.subscribe) {
      request.subscribe(
        (response: any) => this.actualizarUsuarioDesdeResponse(response),
        (error: any) => console.error('Error obteniendo usuario actualizado:', error)
      );
      return;
    }

    if (request.then) {
      request
        .then((response: any) => this.actualizarUsuarioDesdeResponse(response))
        .catch((error: any) => console.error('Error obteniendo usuario actualizado:', error));
    }
  }

  actualizarUsuarioDesdeResponse(response: any): void {
    const usuarioApi = this.extraerUsuarioResponse(response);

    if (!usuarioApi) {
      console.warn('No se encontró usuario en la respuesta:', response);
      return;
    }

    this._usuario = {
      ...this._usuario,
      ...usuarioApi
    };

    // console.log('USUARIO FINAL TALONARIO:', this._usuario);

    if (this._usuario?.doc_id) {
      this.getDocumentosDoctor();
    }
  }

  getDocumentosDoctor(): void {
    const docId = this._usuario?.doc_id;

    if (!docId) {
      console.warn('No se encontró doc_id en _usuario:', this._usuario);
      this.documentosGenerados = [];
      this.documentosGeneradosFiltrados = [];
      return;
    }

    this.loadingDocumentosGenerados = true;

    this.documentsService.getDocumentosDoctor(docId)
      .then((response: any) => {
        const documentos = this.normalizarDocumentosDoctor(response);

        this.documentosGenerados = documentos;
        // console.log(this.documentosGenerados);
        
        this.documentosGeneradosFiltrados = documentos;

        this.tiposDocumentosGenerados = this.obtenerTiposUnicos(documentos);

        this.paginaActual = 1;
        this.filtrarDocumentosGenerados();

        // console.log('DOCUMENTOS DOCTOR RAW:', response);
        // console.log('DOCUMENTOS DOCTOR NORMALIZADOS:', this.documentosGenerados);
      })
      .catch((error: any) => {
        console.error('Error obteniendo documentos del doctor:', error);
        this.documentosGenerados = [];
        this.documentosGeneradosFiltrados = [];
      })
      .finally(() => {
        this.loadingDocumentosGenerados = false;
      });
  }

  normalizarDocumentosDoctor(response: any): any[] {
    const data = this.extraerListaDocumentos(response);

    if (!Array.isArray(data)) {
      return [];
    }

    return data.map((item: any, index: number) => {
      const tipo = this.getTipoDocumentoGenerado(item);
      const fecha = this.getFechaDocumentoGenerado(item);

      return {
        id: item.documento_id || item.att_id || index,
        raw: item,

        nombre: this.getNombrePacienteDocumento(item),
        subtipo: this.getSubtipoDocumentoGenerado(item, tipo),
        tipo,
        origen: this.getOrigenDocumentoGenerado(item),

        fecha,
        fechaTexto: this.formatearFechaTexto(fecha),

        att_id: item.att_id || null,
        att_path: item.att_path || null,
        att_name: item.att_name || null,
        file_name_desc: item.att_name || item.file_name_desc || item.file_name || 'documento.pdf',

        documento_id: item.documento_id || null,
        paciente_id: item.paciente_id || null,
        id_consulta: item.id_consulta || null,
        is_digital_pad: item.is_digital_pad || false
      };
    });
  }

  extraerListaDocumentos(response: any): any[] {
    if (!response) {
      return [];
    }

    if (Array.isArray(response)) {
      return response;
    }

    if (Array.isArray(response.recetas)) {
      return response.recetas;
    }

    if (Array.isArray(response.data)) {
      return response.data;
    }

    if (Array.isArray(response.consulta)) {
      return response.consulta;
    }

    if (Array.isArray(response.documentos)) {
      return response.documentos;
    }

    if (Array.isArray(response.rows)) {
      return response.rows;
    }

    return [];
  }

  getNombrePacienteDocumento(item: any): string {
    const nombreCompleto = [
      item.use_name,
      item.use_paternal_surname,
      item.use_maternal_surname
    ]
      .filter(Boolean)
      .join(' ')
      .trim();

    return item.nombre_paciente ||
      item.patient_name ||
      item.use_full_name ||
      nombreCompleto ||
      item.nombre ||
      'Paciente sin nombre';
  }

  getSubtipoDocumentoGenerado(item: any, tipo: string): string {
    if (item.tipo_nombre) {
      return item.tipo_nombre;
    }

    if (item.pre_typ_name) {
      return item.pre_typ_name;
    }

    if (item.exa_typ_name) {
      return item.exa_typ_name;
    }

    if (item.att_typ_name) {
      return item.att_typ_name;
    }

    if (item.subtipo) {
      return item.subtipo;
    }

    return tipo;
  }

  getTipoDocumentoGenerado(item: any): string {
    const raw = String(
      item.tipo_documento ||
      item.tipo_doc ||
      item.tipo ||
      item.att_typ_name ||
      ''
    ).toUpperCase();

    if (raw.includes('RECETA')) {
      return 'Receta';
    }

    if (raw.includes('ORDEN')) {
      return 'Orden de examen';
    }

    if (raw.includes('EXAMEN')) {
      return 'Orden de examen';
    }

    if (raw.includes('CERTIFICADO')) {
      return 'Certificado médico';
    }

    if (raw.includes('LICENCIA')) {
      return 'Licencia médica';
    }

    return item.tipo_documento || item.tipo_doc || item.tipo || 'Documento';
  }

  getOrigenDocumentoGenerado(item: any): string {
    if (item.origen) {
      return item.origen === 'CONSULTA' ? 'Videoconsulta' : item.origen;
    }

    if (item.is_digital_pad === true || item.is_digital_pad === 'true') {
      return 'Talonario';
    }

    if (item.from_digital_pad || item.generated_from === 'talonario') {
      return 'Talonario';
    }

    if (item.id_consulta || item.med_con_id || item.med_con_app_boo_id || item.tel_doc_app_boo_id) {
      return 'Videoconsulta';
    }

    return 'Talonario';
  }

  getFechaDocumentoGenerado(item: any): string {
    return item.fecha_documento ||
      item.fecha ||
      item.att_date ||
      item.pre_date ||
      item.pre_his_date ||
      item.med_ord_date ||
      item.med_lea_request_date ||
      item.created_at ||
      '';
  }

  formatearFechaTexto(fecha: string): string {
    if (!fecha) {
      return '—';
    }

    const date = new Date(fecha);

    if (isNaN(date.getTime())) {
      return fecha;
    }

    const meses = [
      'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'
    ];

    const dia = String(date.getDate()).padStart(2, '0');
    const mes = meses[date.getMonth()];
    const anio = date.getFullYear();

    return `${dia} ${mes} ${anio}`;
  }

  obtenerTiposUnicos(documentos: any[]): string[] {
    const tipos = documentos
      .map((doc: any) => doc.tipo)
      .filter((tipo: string) => !!tipo);

    return Array.from(new Set(tipos));
  }

  extraerUsuarioResponse(response: any): any {
    if (!response) {
      return null;
    }

    if (response.data && Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }

    if (response.consulta && Array.isArray(response.consulta) && response.consulta.length > 0) {
      return response.consulta[0];
    }

    if (response.usuarios && Array.isArray(response.usuarios) && response.usuarios.length > 0) {
      return response.usuarios[0];
    }

    if (Array.isArray(response) && response.length > 0) {
      return response[0];
    }

    if (response.usuario) {
      return response.usuario;
    }

    if (response.data && !Array.isArray(response.data)) {
      return response.data;
    }

    return response;
  }

  isTrue(value: any): boolean {
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  get canUseDigitalPad(): boolean {
    return this.isTrue(this._usuario?.doc_check_can_use_digital_pad);
  }

  get filteredDocuments() {
    const value = this.searchDocument.toLowerCase().trim();

    let docs = this.documents.filter(document =>
      this.canGenerateDocument(document)
    );

    if (value) {
      docs = docs.filter(document =>
        document.title.toLowerCase().includes(value) ||
        document.description.toLowerCase().includes(value)
      );
    }

    return docs;
  }

  canGenerateDocument(document: any): boolean {
    if (!document || !document.permission) {
      return false;
    }

    return this.isTrue(this._usuario?.[document.permission]);
  }

  openDocument(document: any): void {
    if (!this.canGenerateDocument(document)) {
      return;
    }

    switch (document.id) {
      case 'receta':
        this.router.navigate(['/talonario/receta']);
        break;

      case 'orden-examen':
        this.router.navigate(['/talonario/orden-examen']);
        break;

      case 'certificado':
        this.router.navigate(['/talonario/certificado']);
        break;
    }
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  cerrarFiltros(): void {
    this.mostrarFiltros = false;
  }

  filtrarDocumentosGenerados(): void {
    let data = [...this.documentosGenerados];

    const nombre = this.filtrosGenerados.nombre.toLowerCase().trim();

    if (nombre) {
      data = data.filter((doc: any) =>
        String(doc.nombre || '').toLowerCase().includes(nombre)
      );
    }

    if (this.filtrosGenerados.fechaDesde) {
      data = data.filter((doc: any) =>
        doc.fecha && doc.fecha.substring(0, 10) >= this.filtrosGenerados.fechaDesde
      );
    }

    if (this.filtrosGenerados.fechaHasta) {
      data = data.filter((doc: any) =>
        doc.fecha && doc.fecha.substring(0, 10) <= this.filtrosGenerados.fechaHasta
      );
    }

    if (this.filtrosGenerados.tipos.length > 0) {
      data = data.filter((doc: any) =>
        this.filtrosGenerados.tipos.includes(doc.tipo)
      );
    }

    this.documentosGeneradosFiltrados = data;

    this.paginaActual = 1;
    this.actualizarPaginacion();
  }

  limpiarFiltrosGenerados(): void {
    this.filtrosGenerados = {
      nombre: '',
      fechaDesde: '',
      fechaHasta: '',
      tipos: []
    };

    this.filtrarDocumentosGenerados();
  }

  hasFiltrosActivos(): boolean {
    return !!(
      this.filtrosGenerados.nombre ||
      this.filtrosGenerados.fechaDesde ||
      this.filtrosGenerados.fechaHasta ||
      this.filtrosGenerados.tipos.length > 0
    );
  }

  isTipoGeneradoSelected(tipo: string): boolean {
    return this.filtrosGenerados.tipos.includes(tipo);
  }

  toggleTipoGenerado(tipo: string, checked: boolean): void {
    if (checked) {
      if (!this.filtrosGenerados.tipos.includes(tipo)) {
        this.filtrosGenerados.tipos.push(tipo);
      }
    } else {
      this.filtrosGenerados.tipos = this.filtrosGenerados.tipos.filter(t => t !== tipo);
    }

    this.filtrarDocumentosGenerados();
  }

  getIconoDocumentoGenerado(tipo: string): string {
    switch (tipo) {
      case 'Receta':
        return 'fi fi-rr-prescription-bottle';

      case 'Orden de examen':
        return 'fi fi-rr-add-document';

      case 'Orden médica':
        return 'fi fi-rr-add-document';

      case 'Certificado médico':
        return 'fi fi-rr-document-signed';

      case 'Licencia médica':
        return 'fi fi-rr-document';

      default:
        return 'fi fi-rr-document';
    }
  }

  descargarDocumentoGenerado(doc: any): void {
    if (!doc) {
      return;
    }

    if (doc.att_id) {
      this.generalService.descargarFileAtt(
        doc.att_id,
        doc.file_name_desc || doc.nombre || 'documento',
        null
      );
      return;
    }

    if (doc.raw?.att_id) {
      this.generalService.descargarFileAtt(
        doc.raw.att_id,
        doc.raw.file_name_desc || doc.raw.file_name || doc.nombre || 'documento',
        null
      );
      return;
    }

    console.warn('Documento sin archivo para descargar:', doc);
  }

  actualizarPaginacion(): void {
    const total = this.documentosGeneradosFiltrados.length;

    this.totalPaginas = Math.ceil(total / this.itemsPorPagina) || 1;

    if (this.paginaActual > this.totalPaginas) {
      this.paginaActual = this.totalPaginas;
    }

    if (this.paginaActual < 1) {
      this.paginaActual = 1;
    }

    const inicio = (this.paginaActual - 1) * this.itemsPorPagina;
    const fin = inicio + this.itemsPorPagina;

    this.documentosGeneradosPaginados = this.documentosGeneradosFiltrados.slice(inicio, fin);
  }

  cambiarItemsPorPagina(value: any): void {
    this.itemsPorPagina = Number(value) || 10;
    this.paginaActual = 1;
    this.actualizarPaginacion();
  }

  irPaginaAnterior(): void {
    if (this.paginaActual <= 1) {
      return;
    }

    this.paginaActual--;
    this.actualizarPaginacion();
  }

  irPaginaSiguiente(): void {
    if (this.paginaActual >= this.totalPaginas) {
      return;
    }

    this.paginaActual++;
    this.actualizarPaginacion();
  }

  irPagina(pagina: number): void {
    if (pagina < 1 || pagina > this.totalPaginas) {
      return;
    }

    this.paginaActual = pagina;
    this.actualizarPaginacion();
  }

  getPaginasVisibles(): number[] {
    const paginas: number[] = [];
    const maxVisible = 5;

    let inicio = Math.max(1, this.paginaActual - 2);
    let fin = Math.min(this.totalPaginas, inicio + maxVisible - 1);

    if (fin - inicio < maxVisible - 1) {
      inicio = Math.max(1, fin - maxVisible + 1);
    }

    for (let i = inicio; i <= fin; i++) {
      paginas.push(i);
    }

    return paginas;
  }

  getDesdeRegistro(): number {
    if (this.documentosGeneradosFiltrados.length === 0) {
      return 0;
    }

    return ((this.paginaActual - 1) * this.itemsPorPagina) + 1;
  }

  getHastaRegistro(): number {
    const hasta = this.paginaActual * this.itemsPorPagina;
    return Math.min(hasta, this.documentosGeneradosFiltrados.length);
  }
}